import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import DownIcon from 'mdi-react/ChevronDownIcon';
import CheckIcon from 'mdi-react/CheckIcon';
import LogoutIcon from 'mdi-react/LogoutIcon';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AuthService from '../../_app/AuthService';
import userLanguageState from '../../../recoil/userLanguage/selector';
import {
  partial,
  getAvailableLanguages,
} from '../../../util/translation/translation';

const s = partial('shared');
const TopbarProfile = ({ me, dispatch }) => {
  const [collapse, setCollapse] = useState(false);
  const [currentLanguage, setUserLanguage] = useRecoilState(userLanguageState);

  const toggle = () => {
    setCollapse(!collapse);
  };
  const logOut = () => {
    AuthService.signout(dispatch).catch((err) => console.error(err));
  };
  const changeLanguage = (value) => () => {
    setUserLanguage(value);
    setCollapse(false);
  };
  return (
    <div className="topbar__profile">
      <button className="topbar__avatar" onClick={toggle}>
        <div className="topbar__avatar-icon">{`${me?.firstname?.[0]?.toUpperCase() ?? ''}${me?.lastname?.[0]?.toUpperCase() ?? ''}`}</div>
        <p className="topbar__avatar-name">
          {me?.firstname} {me?.lastname}
        </p>
        <DownIcon className="topbar__icon" />
      </button>
      {collapse && <button className="topbar__back" onClick={toggle} />}
      <Collapse isOpen={collapse} className="topbar__menu-wrap">
        <div className="topbar__menu">
          <div className="topbar__menu-label">{s('language')}</div>
          {getAvailableLanguages().map((language) => {
            const active = language.value === currentLanguage;
            return (
              <button
                key={`topBarLanguage-${language.value}`}
                type="button"
                className="topbar__link btn-noStyle"
                onClick={changeLanguage(language.value)}
                aria-pressed={active}
              >
                <p className="topbar__link-title">{language.label}</p>
                {active && <CheckIcon className="topbar__link-check" />}
              </button>
            );
          })}
          <div className="topbar__menu-divider" />
          <Link className="topbar__link" to="/email_login" onClick={logOut}>
            <LogoutIcon className="topbar__link-mdi" />
            <p className="topbar__link-title">{s('logOut')}</p>
          </Link>
        </div>
      </Collapse>
    </div>
  );
};

TopbarProfile.propTypes = {
  me: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

TopbarProfile.defaultProps = {
  me: null,
};

export default withRouter(
  connect((state) => ({
    sidebar: state.sidebar,
    me: state.admin.me,
  }))(TopbarProfile)
);
